module.exports = __webpack_public_path__ + "static/media/08_Azonto (vocal up)_eq 08-23.dbd6a744.mp3";